export const  SEARCH_PAGE={
    SEARCH_PAGE_FETCH : "SEARCH_PAGE_FETCH",
    SEARCH_TYPE_FETCH : "SEARCH_TYPE_FETCH",
    SEARCH_TYPE_FLEET_FETCH : "SEARCH_TYPE_FLEET_FETCH",
    IS_GLOBAL_SEARCH_FIELD: "IS_GLOBAL_SEARCH_FIELD",
    IS_TRIP_FILTER_SEARCH_FIELD : "IS_TRIP_FILTER_SEARCH_FIELD"
};


  